import { usePortalSettings } from '@servicetitan/cp-ui';
import { ButtonPropsStrict } from '@servicetitan/design-system';

export const useCallUsProps = (): ButtonPropsStrict & { children: string } => {
    const { phoneNumber } = usePortalSettings() ?? {};

    return {
        href: `tel:${phoneNumber}`,
        fill: 'outline',
        primary: true,
        iconName: 'local_phone',
        iconPosition: 'left',
        children: 'Call Us',
    };
};
